var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home pb-5"},[_c('detail-table-logs',{ref:"logTable",staticClass:"mx-7 mt-7"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }